import { Box, Chip, Typography, ChipProps, Stack } from '@mui/material'
import { AppUser, AppUserStatus_Status } from 'pbts/c1/api/app/v1/app_user'
import React from 'react'
import { IntlShape, useIntl } from 'react-intl'

type AppUserStatusProps = {
    appUser?: AppUser
}

const formatDetails = (details: string): string => {
    // TODO(morgabra) Do this on the backend?
    return details
        .split('_')
        .map((part) => {
            if (!part.length) {
                return part
            }
            part = part.toLowerCase()
            part = part.charAt(0).toUpperCase() + part.slice(1)
            return part
        })
        .join(' ')
}

const getStatusString = (v: AppUserStatus_Status, intl: IntlShape): string => {
    switch (v) {
        case AppUserStatus_Status.ENABLED:
            return intl.formatMessage({
                id: 'app_user_status_enabled',
                defaultMessage: 'Enabled',
            })
        case AppUserStatus_Status.DISABLED:
            return intl.formatMessage({
                id: 'app_user_status_disabled',
                defaultMessage: 'Disabled',
            })
        case AppUserStatus_Status.DELETED:
            return intl.formatMessage({
                id: 'app_user_status_deleted',
                defaultMessage: 'Deleted',
            })
        case AppUserStatus_Status.UNSPECIFIED: // fallthrough
        default:
            return intl.formatMessage({
                id: 'app_user_status_unspecified',
                defaultMessage: 'Unspecified',
            })
    }
}

const statusToChipColor = (status: AppUserStatus_Status): ChipProps['color'] => {
    switch (status) {
        case AppUserStatus_Status.ENABLED:
            return 'success'
        case AppUserStatus_Status.DISABLED:
            return 'warning'
        case AppUserStatus_Status.DELETED:
            return 'error'
        case AppUserStatus_Status.UNSPECIFIED:
            return 'default'
        // no default
    }
}

export const AppUserStatus = (appUserStatus: AppUserStatusProps): React.ReactElement | null => {
    const intl = useIntl()

    if (
        !appUserStatus.appUser
        || !appUserStatus.appUser.status
        || appUserStatus.appUser.status.status === AppUserStatus_Status.UNSPECIFIED
    ) {
        return null
    }

    return (
        <Box>
            <Chip
                color={statusToChipColor(appUserStatus.appUser.status.status)}
                label={
                    <Stack spacing={1} direction="row" alignItems="center">
                        <Box>
                            <Typography>
                                {appUserStatus.appUser.status.details
                                    ? formatDetails(appUserStatus.appUser.status.details)
                                    : getStatusString(appUserStatus.appUser.status.status, intl)}
                            </Typography>
                        </Box>
                    </Stack>
                }
            />
        </Box>
    )
}
